export const HEADING = 'Please sign in to continue…';
export const MESSAGE =
  "If you're using your personal email for the existing account, consider creating a new account using your business email.";
export const SIGN_IN_CTA = 'Sign in';
export const REGISTER_CTA = 'Create a new account';
